<script>
	import API from '../../States/API';
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Pattern from '../../Models/Pattern';
	import Router from '../../States/Router';
	import Session from '../../States/Session';
	import Scripture from '../../Models/Scripture';
	import Slider from '../../States/Slider';
	import Trigger from '../../Models/Trigger';
	import {afterUpdate, onDestroy} from 'svelte';

	export let index = 0;

	let properties = {};
	let content = {};
	let book = {};
	let chapter = {};
	let uri = {};
	let intro = {html: ''};
	let references = [];

	let active = false;
	let old_active = false;
	let feature = false;
	let intro_full = false;
	let connected = false;
	let chapter_list = false;

	let audio = {};
	let audio_loading = false;
	let audio_ready = false;
	let audio_playing = false;

	let audio_frame = 0;
	let audio_last_time = 0;
	let audio_current_time = 0;
	let audio_last_scroll_top = 0;
	let audio_current_scroll_top = 0;
	let audio_scroll_offset = 0;
	let audio_scroll_abort = false;
	let audio_scrolling = false;

	let favorites = [];
	let favorite = {number: 0, remove: false, note: ''};
	let favorite_node = false;
	let favorite_element = {};
	let favorite_textarea = {};

	async function updateSlider(slides) {
		active = Slider.check(index, ['chapter', 'reference'], properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			old_active = properties.old_active;
			feature = !isType('chapter');

			const changed = !Helper.is(chapter) || (properties.chapter != chapter.code);
			if (changed) {
				audioDestroy();
				await load();
			}

			if (changed && active) {
				connected = false;
				references = [];

				zoom();
				title();
				canonical();
				connect();
			}
		}
	}

	async function load() {
		if (properties.chapter) {
			jQuery(content).scrollTop(0);

			const code = properties.chapter;
			const code_book = Pattern.get(code, /^([^_]+)/);
			chapter = await Data.relative(`books/${code_book}/${code}`);
			book = await Data.relative(`books/${code_book}`);
			title();
			canonical();

			if (isType('chapter')) {
				const intros = await Data.relative('intro/index');
				if (!Helper.undefined(intros[properties.chapter])) {
					intro = await Data.relative(`intro/${properties.chapter}`);
					intro.summary = Pattern.get(intro.html, /^(<p>.+?<\/p>)/ms);
					intro.expand = false;
				}
				else intro = {html: ''};
			}
			else intro = {html: ''};

			const previous_chapter = await Scripture.previousChapter(code);
			const next_chapter = await Scripture.nextChapter(code);
			uri = {previous: previous_chapter, next: next_chapter};
		}
	}

	async function connect() {
		const loaded = Helper.is(chapter);
		const populated = connected || !!jQuery(content).find(`a[data-verse]`).length;
		if (loaded && !connected && populated) {
			connected = true;
			connectVerses();
			connectPericope();
			connectNote();
			connectRedirect();
			connectReference();
			connectFavorite();

			const initial = Helper.undefined(old_active);
			if ($Data.version.side_reference && initial)
				references = await sideReferences();
		}
	}

	async function sideReferences() {
		const references = [];
		const cache = [];
		const positions = [];
		const locations = jQuery(content).find('span[data-type="ref"][data-loc]');

		const html = chapter.html;
		const pattern = /<span\s+data-type="ref"\s+data-loc=".+?">(.+?)<\/span>/ig;
		const matches = Pattern.list(html, pattern);
		for (const match of matches) {
			const label = match[1];
			if (!cache.includes(label)) {
				cache.push(label);
				const reference = await Scripture.reference(label);
				if (Helper.is(reference))
					locations.each(function(index, item) {
						const element = jQuery(item);
						if (element.text() == label) {
							const marker = element.parents('span[data-type="note"]').prev();
							let top = marker.offset().top - jQuery(content).offset().top + jQuery(content).scrollTop() - 45;
							while (positions.includes(top)) top += 25;
							const click = event => { Slider.route(['reference', [reference]]) };
							const thing = {name: reference.name, top, click};
							references.push(thing);
							positions.push(top);
						}
					});
			}
		}

		return references;
	}

	function connectVerses() {
		const check = properties.reference && properties.reference.verses && properties.reference.verses.length;
		if (check) {
			const list = properties.reference.verses.map(x => + x);
			const first = jQuery(content).find(`a[data-verse="${list[0]}"]`).parentsUntil('p').parent();
			if (first.length) {
				let current = 0;
				jQuery(content).find('x-v').each((index, element) => {
					const verse = jQuery(element).find('a').data('verse');
					current = verse || current;
					const active = list.includes(current);
					if (active) jQuery(element).addClass('active');
				});

				const top = first.offset().top - jQuery(content).offset().top + jQuery(content).scrollTop();
				jQuery(content).scrollTop(top - 55);
			}
		}
	}

	function connectPericope() {
		if (Helper.is(properties.pericope)) {
			const selector = `h3[data-anchor="${properties.pericope}"]`;
			const element = jQuery(content).find(selector);
			if (element.length) {
				const head = 25;
				const top = element.offset().top - jQuery(content).offset().top + jQuery(content).scrollTop() - head;
				jQuery(content).animate({scrollTop: top}, 1000 * .5);
			}
		}
	}

	function connectNote() {
		const icon = jQuery(content).find('i.fa-question-circle');
		icon.off('click').on('click', function(event) {
			const current = jQuery(this);
			const open = !!current.hasClass('fa-times-circle');
			const note = current.next('span[data-type="note"]');
			if (note.length) {
				jQuery(note[0]).toggleClass('show');
				current[open ? 'removeClass' : 'addClass']('fa-times-circle');
				current[open ? 'addClass' : 'removeClass']('fa-question-circle');
			}
		});
	}

	function connectRedirect() {
		const icon = jQuery(content).find('i.fa-location-circle');
		icon.off('click').on('click', function(event) {
			const current = jQuery(this);
			const open = !!current.hasClass('fa-times-circle');
			const note = current.next('span[data-type="note"]');
			if (note.length) {
				jQuery(note[0]).toggleClass('show');
				current[open ? 'removeClass' : 'addClass']('fa-times-circle');
				current[open ? 'addClass' : 'removeClass']('fa-location-circle');
			}
		});
	}

	function connectReference() {
		const references = jQuery(content).find('span[data-type="ref"][data-loc]');
		references.off('click').on('click', async function(event) {
			const label = jQuery(this).text();
			const reference = await Scripture.reference(label);
			if (Helper.is(reference))
				Slider.route(['reference', [reference]]);
		});
	}

	/* Favorite */

	async function connectFavorite() {
		favoriteLabels();
		favoriteHovers();
		favoriteClicks();
	}

	async function favoriteLabels() {
		if (!$Session.authentication.active) return;

		favorites = [];
		jQuery(content).find('i.favorite-note').remove();

		const response = await API.favorites();
		const bookmarks = response.bookmarks;
		if (Array.isArray(bookmarks)) {
			const pattern = new RegExp(`^${chapter.code}_([0-9]+)$`, 'i');
			bookmarks.forEach(bookmark => {
				const match = bookmark.verse.match(pattern);
				if (match) {
					favorites.push(bookmark);
					const element = jQuery(content).find(`a[data-verse="${match[1]}"]`);
					favoriteActive(element, bookmark);
					if (Helper.is(bookmark.note)) {
						const note = jQuery('<i class="fad fa-comment-alt-lines favorite-note"></i>');
						note.on('click', function() { jQuery(this).prevAll('a[data-verse]').trigger('click'); });
						note.insertAfter(element);
					}
				}
			});
		}
	}

	function favoriteHovers() {
		if (!$API.active || Helper.touch()) return;

		let timer = 0;
		const hide = () => {
			jQuery(content).find('a[data-verse]').each((index, item) => {
				const element = jQuery(item);
				element.html(element.data('verse'));
			});
		};

		const show = element => {
			hide();
			const label = element.find('a[data-verse]');
			if (!label.parent().data('bookmark'))
				label.html('<i class="far fa-heart"></i>');
		};

		const verses = jQuery(content).find('x-v');
		verses.off('mouseover').on('mouseover', function(event) {
			const element = jQuery(this);
			const unmarked = !element.data('favorite');
			if (unmarked) clearTimeout(timer);
			const target = event.target == event.currentTarget;
			if (target && unmarked)
				show(element);
		});

		verses.off('mouseout').on('mouseout', function(event) {
			clearTimeout(timer);
			const element = jQuery(this);
			const target = event.target == event.currentTarget;
			if (target) timer = setTimeout(hide, 1000 * 1);
		});
	}

	async function favoriteClicks() {
		if (!$API.active) return;

		const buttons = jQuery(content).find('a[data-verse]');
		buttons.off('click').on('click', function(event) {
			if ($Session.authentication.active) {
				const open = isFavoriteOpen(this);
				if (!open) {
					favorite.note = '';
					favorite.remove = false;
					favorite.number = jQuery(this).data('verse');
					jQuery(favorite_textarea).val('');

					const active = isFavoriteActive(this);
					if (active) {
						const bookmark = favoriteBookmark(this);
						favorite.note = bookmark.note || '';
						jQuery(favorite_textarea).val(favorite.note);
						favoriteOpen(this);
					}
					else favoriteInsert(this, favorite);
				}
				else favoriteClose(this);
			}

			else {
				let message = 'Je moet eerst inloggen om een favoriet te bewaren.';
				Trigger.event('alert', {icon: 'heart', message});
			}
		});
	}

	function isFavoriteOpen(node) {
		const element = jQuery(node);
		const open = element.parent().data('open');
		return !!open;
	}

	function favoriteOpen(node) {
		if (!isFavoriteOpen(node)) {
			if (favorite_node) favoriteClose();
			favorite_node = node;

			const element = jQuery(node);
			element.parent().data('open', true);
			element.after(favorite_element);
			jQuery(favorite_element).addClass('show');
		}
	}

	function favoriteClose(node) {
		if (!node) node = favorite_node;
		if (node) {
			const element = jQuery(node);
			element.parent().data('open', false);
			favorite_node = false;
		}

		jQuery(favorite_element).removeClass('show');
	}

	function isFavoriteActive(node) {
		const element = jQuery(node);
		const bookmark = element.parent().data('bookmark');
		return !!bookmark;
	}

	function favoriteActive(node, bookmark) {
		const element = jQuery(node);
		element.attr('class', 'favorite');
		element.parent().data('bookmark', bookmark);
		element.html(element.data('verse'));
		return element;
	}

	function favoriteInactive(node) {
		const element = jQuery(node);
		element.attr('class', '');
		element.parent().data('bookmark', false);
		element.html(element.data('verse'));
		return element;
	}

	function favoriteBookmark(node) {
		const element = jQuery(node);
		const bookmark = element.parent().data('bookmark');
		return bookmark;
	}

	async function favoriteInsert(node, favorite) {
		if (Helper.onlineNotice()) {
			const verse = `${chapter.code}_${favorite.number}`;
			const bookmark = {verse};

			favoriteOpen(node);
			favoriteActive(node, bookmark);
			await API.insertFavorite(bookmark);
			favoriteLabels();

			let message = `${chapter.book.name} ${chapter.number}:${favorite.number} `;
			message += 'is aan je favorieten toegevoegd.';
			Trigger.event('alert', {icon: 'heart', message});
		}
	}

	async function favoriteUpdate(favorite) {
		if (Helper.onlineNotice()) {
			const verse = `${chapter.code}_${favorite.number}`;
			const note = jQuery(favorite_textarea).val() || '';
			await API.updateFavorite({verse, note});
			favoriteLabels();

			const element = jQuery(favorite_node);
			const message = 'Jouw notitie is opgeslagen';
			Trigger.event('alert', {icon: 'heart', message});

			favoriteClose(favorite_node);
		}
	}

	async function favoriteDelete(favorite) {
		if (Helper.onlineNotice()) {
			const verse = `${chapter.code}_${favorite.number}`;
			await API.deleteFavorite({verse});
			favoriteLabels();

			const element = jQuery(favorite_node);
			let message = `${chapter.book.name} ${chapter.number}:${element.data('verse')} `;
			message += 'is uit je favorieten verwijderd.';
			Trigger.event('alert', {icon: 'heart', message});

			favoriteInactive(favorite_node);
			favoriteClose(favorite_node);
		}
	}

	/* Navigation */

	function toPericope(item) {
		properties.pericope = item.code;
		connectPericope();
	}

	function chapterPrevious(event) {
		Helper.prevent(event);
		Router.push(`/${uri.previous.chapter.uri}`);
		Slider.previous();
	}

	function chapterNext(event) {
		Helper.prevent(event);
		Router.push(`/${uri.next.chapter.uri}`);
		Slider.next();
	}

	function referencePrevious(event) {
		Helper.prevent(event);
		Slider.route(['chapter', [uri.previous.chapter.code]])
	}

	function referenceNext(event) {
		Helper.prevent(event);
		Slider.route(['chapter', [uri.next.chapter.code]])
	}

	function bookmark(code) {
		if (Helper.onlineNotice()) {
			Session.updateBookmark(code);
			const location = `${chapter.book.name} ${chapter.number}`;
			const add = `Bladwijzer is geplaatst op ${location}.`;
			const remove = `Bladwijzer is verwijderd.`;
			const message = code ? add : remove;
			Trigger.event('alert', {icon: 'bookmark', message});
		}
	}

	function isType(check) {
		return properties.type == check;
	}

	function isReferenceProceed() {
		return properties.reference && properties.reference.proceed;
	}

	function title() {
		if (active) {
			const book_name = (book.name === 'Psalmen') ? 'Psalm' : book.name;
			Helper.title(`${book_name} ${chapter.number}`);
		}
	}

	function canonical() {
		if (isType('chapter') && active)
			Helper.canonical(`${book.uri}/${chapter.number}`);
	}

	/* Audio */

	function audioLoading(event) {
		audio_loading = true;
		audio_ready = false;
	}

	function audioReady(event) {
		const anchor = jQuery(content).find('h3[data-anchor]:first');
		const style = window.getComputedStyle(anchor[0]);
		const margin = style.getPropertyValue('margin-top');
		audio_scroll_offset = anchor.position().top;
		audio_scroll_offset += parseInt(margin);

		audio_loading = false;
		audio_ready = true;
		audio.play();
	}

	function audioPlay(event) {
		audio_playing = true;
	}

	function audioUserScroll() {
		if (audio_playing) {
			audio_scroll_abort = true;
			content.removeEventListener('scroll', audioUserScroll);
		}
	}

	function audioScroll(timestamp) {
		const progress = (timestamp - audio_last_time) / (audio.duration * 1000);
		const interpolated = audio_last_scroll_top + (audio_current_scroll_top - audio_last_scroll_top) * progress;
		const top = interpolated + audio_scroll_offset;
		content.scrollTop = top;
		if (!audio_scroll_abort && audio_playing && (interpolated < audio_current_scroll_top))
			audio_frame = requestAnimationFrame(audioScroll);
	}

	function audioTime(event) {
		audio_last_time = audio_current_time;
		audio_current_time = audio.currentTime * 1000;
		audio_last_scroll_top = audio_current_scroll_top;
		const max_scroll_top = content.scrollHeight - content.clientHeight;
		audio_current_scroll_top = max_scroll_top * (audio.currentTime / audio.duration);

		cancelAnimationFrame(audio_frame);
		if (!audio_scroll_abort && audio_playing)
			audio_frame = requestAnimationFrame(audioScroll);
	}

	function audioPause(event) {
		audio_playing = false;
	}

	function audioEnded(event) {
		audio_playing = false;
	}

	function audioToggle() {
		if ($API.active) {
			if (!Helper.is(audio)) {
				const root = `${$Data.version.site}/audio`;
				const group = `${$Data.version.code}/${book.code}`;
				const file = `${chapter.code}.mp3`;
				const source = `${root}/${group}/${file}`;

				audio = new window.Audio(source);
				audio.load();

				audio.addEventListener('loadstart', audioLoading);
				audio.addEventListener('canplaythrough', audioReady);
				audio.addEventListener('play', audioPlay);
				audio.addEventListener('timeupdate', audioTime);
				audio.addEventListener('pause', audioPause);
				audio.addEventListener('ended', audioEnded);
				jQuery(content).on('click touchstart wheel', audioUserScroll);
			}

			else if (audio_ready) {
				const action = audio_playing ? 'pause' : 'play';
				audio[action]();
			}
		}

		else {
			const message = 'Deze functie vereist verbinding met het internet.';
			Trigger.event('alert', {icon: 'wifi-slash', message});
		}
	}

	function audioDestroy() {
		if (Helper.is(audio)) {
			cancelAnimationFrame(audio_frame);
			audio.removeEventListener('loadstart', audioLoading);
			audio.removeEventListener('canplaythrough', audioReady);
			audio.removeEventListener('play', audioPlay);
			audio.removeEventListener('timeupdate', audioTime);
			audio.removeEventListener('pause', audioPause);
			audio.removeEventListener('ended', audioEnded);
			jQuery(content).off('click touchstart wheel');
			audio.pause();

			audio = {};
			audio_loading = false;
			audio_ready = false;
			audio_playing = false;

			audio_frame = 0;
			audio_last_time = 0;
			audio_current_time = 0;
			audio_last_scroll_top = 0;
			audio_current_scroll_top = 0;
			audio_scroll_offset = 0;
			audio_scroll_abort = false;
		}
	}

	/* Zoom */

	function zoom() {
		const offset = $Session.read.size.offset;
		if (!jQuery(content).data('size')) {
			let source = jQuery(content).css('font-size');
			source = source.replace(/[^0-9\.]/g, '');
			jQuery(content).data('size', source);
		}

		let size = jQuery(content).data('size');
		size = (size * 1) + (offset * 1);
		jQuery(content).css('font-size', `${size}px`);
	}

	function zoomIn() {
		if ($Session.read.size.offset < 7) {
			$Session.read.size.offset++;
			zoom();
		}
	}

	function zoomOut() {
		if ($Session.read.size.offset > -7) {
			$Session.read.size.offset--;
			zoom();
		}
	}

	Slider.subscribe(updateSlider);

	onDestroy(() => {
		audioDestroy();
	});
</script>

<style>
	h1 {
		font-size: 3em;
		font-weight: 400;
		font-family: Bitter, serif;
		letter-spacing: -.025em;
		line-height: normal;
		color: var(--primary-color);
		margin: 0 0 .4em 0;
	}

	h1 span {
		letter-spacing: -1px;
		color: var(--secondary-color);
		border-bottom: 4px dashed var(--primary-background-light);
		cursor: pointer;
	}

	div.chapters {
		margin-bottom: 2em;
	}

	div.chapters a {
		display: inline-block;
		font-family: Bitter, serif;
		font-size: .8em;
		font-weight: 700;
		line-height: 2em;
		color: var(--primary-color);
		width: 2.3em;
		background: var(--secondary-background-light);
		text-align: center;
		border-radius: .3em;
		padding: .1em 0;
		margin: 0 .75em .75em 0;
	}

	div.chapters a.active {
	    color: var(--background);
    	background: var(--primary-color);
    }

	div.bookmark {
		position: absolute;
		top: -3em;
		right: 13%;
		width: 2.5em;
		height: 5em;
		cursor: pointer;
	}

	div.bookmark:not(.active) .element {
		fill: var(--primary-color-lightest);
	}

	div.bookmark.active .element {
		fill: var(--primary-color);
	}

	div.menu div.title a {
		display: inline-block;
		background: var(--secondary-background-light);
		border-radius: .3em;
		padding: .975em .7em;
		font-size: .85em;
		line-height: 0;
		cursor: pointer;
	}

	div.menu div.title a i {
		line-height: 0;
		margin-right: .2em;
	}

	div.duo {
		display: flex;
	}

	div.duo div.chapter {
		width: 82.5%;
		padding-right: 11%;
		border-right: 1px solid var(--primary-background-light);
		position: relative;
	}

	div.list div.name i {
		margin-right: .75em;
		opacity: .5;
	}

	div.duo div.reference {
		position: relative;
		width: 17.5%;
		opacity: 0;
		will-change: opacity;
	}

	div.duo div.reference.active {
		opacity: 1;
		transition: opacity .3s ease-out;
	}

	div.duo div.reference div.note {
		font-size: .75em;
		font-weight: bold;
		line-height: 1.7em;
		color: var(--tertiary-color);
		border-radius: .3em;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		padding: .25em 1em;
		margin-top: 45%;
		background: var(--tertiary-background-light-solid);
	}

	div.duo div.reference div.note h4 {
		font-weight: normal;
		font-size: .8em;
		text-transform: uppercase;
	}

	div.duo div.reference div.note p {
		margin-bottom: 1em;
	}

	div.duo div.reference div.note i {
		opacity: 1;
	}

	div.duo div.reference div.note span.verse {
		display: inline-block;
		font-size: .7em;
		font-weight: 700;
		line-height: 1.6em;
		color: var(--tertiary-color);
		padding: .25em .7em 0 .7em;
		margin: 0 .5em;
		border-radius: .3em;
		background: var(--tertiary-background-light);
		vertical-align: middle;
	}

	div.duo div.reference > h4 {
		font-size: .65em;
		text-transform: uppercase;
		color: var(--tertiary-color);
		margin-top: 3.5em;
		padding-left: 1em;
		opacity: .5;
	}

	div.duo div.reference div.item {
		position: absolute;
		display: inline-block;
		background: var(--tertiary-background-light-solid);
		border-radius: .3em;
		border-bottom-left-radius: 0;
		padding: .5em .7em;
		font-size: .65em;
		font-weight: bold;
		line-height: 1.4em;
		color: var(--tertiary-color);
		text-transform: uppercase;
		cursor: pointer;
	}

	div.duo div.reference div.item::after {
		content: ' ';
		position: absolute;
		width: 0;
		height: 0;
		top: 0;
		right: auto;
		bottom: auto;
		left: -1em;
		border: 1em solid;
		border-color: var(--tertiary-background-light-solid) transparent transparent transparent;
	}

	div.duo div.reference div.item > div {
		display: inline-block;
	}

	div.duo div.reference div.item i {
		margin-right: .4em;
	}

	h3.intro {
		color: var(--tertiary-color);
		margin-top: 1em;
	}

	div.intro {
		color: var(--tertiary-color);
		overflow: auto;
		margin-bottom: 0;
		position: relative;
	}

	div.duo-button {
		display: flex;
		justify-content: space-between;
    	flex-direction: row;
		margin-top: 4em;
	}

	.step.button {
		color: var(--tertiary-color);
		background: var(--tertiary-background-light);
		width: 100%;;
	}

	.step.button:first-child {
		margin-right: 1em;
	}

	.step.button:last-child {
		margin-left: 1em;
	}

	.more.button {
		font-size: .7em;
		padding: .25em .5em;
	}

	div.pericopes.list {
		color: var(--tertiary-color);
	}

	div.pericopes.list > .item {
		border-bottom: 2px solid var(--tertiary-background-light);
	}

	div.pericopes.list > .item > div {
		line-height: 1.5em;
	}

	div.pericopes.list div.name {
		margin-right: 1em;
	}

	div.verse-note div.header {
		display: flex;
		margin-bottom: .2em;
		justify-content: space-between;
	}

	div.verse-note div.header div.title {
		font-size: .7em;
		text-transform: uppercase;
		opacity: .75;
	}

	div.verse-note textarea {
		font-size: .7em;
		font-weight: normal;
		color: var(--box-color);
		width: 100%;
		height: 10em;
		padding: 0.5em 1em;
		border-radius: 0.3em;
		border: 1px solid var(--primary-background-light);
		background: var(--box-background-focus);
	}

	div.verse-note textarea::placeholder {
		color: var(--box-color);
	}

	div.verse-note div.toolbar {
		font-size: .7em;
		line-height: 1em;
		padding: .5em 0;
		gap: 0 2em;
		display: flex;
	}

	div.verse-note div.option {
		cursor: pointer;
	}

	div.verse-note div.toolbar div.option i {
		margin-right: .25em;
	}

	div.verse-note div.toolbar div.option.success {
		color: var(--success-color);
	}

	div.verse-note div.toolbar div.option.error {
		color: var(--error-color);
	}

	:global(html.dark div.box.chapter div.verse-note div.toolbar div.option.success),
	:global(html.dark div.box.chapter div.verse-note div.toolbar div.option.error) {
		color: var(--tertiary-color);
	}

	:global(div.box.chapter div.intro.expand) {
		margin-bottom: 1em;
	}

	:global(div.box.chapter div.intro p:last-child) {
		margin-bottom: 0;
	}

	:global(div.box.chapter div.intro.expand p:first-child) {
		font-size: 1.25em;
		margin-top: 1em;
	}

	:global(div.box.chapter div.chapter) {
		font-size: 1.1em;
		line-height: 2em;
	}

	:global(div.box.chapter h3) {
		padding-bottom: .35em;
		border-bottom: 4px solid var(--primary-background-light);
		margin-bottom: 1em;
	}

	:global(div.box.chapter h3 i) {
		float: right;
		font-size: .75em;
		padding: .4em .2em 0 0;
		opacity: .5;
	}

	:global(div.box.chapter div.intro p) {
		margin: 1em 0;
	}

	:global(div.box.chapter div.intro p:first-of-type) {
		margin-top: 0 !important;
	}

	:global(div.box.chapter p) {
		margin: 0;
	}

	:global(html.VB div.box.chapter p.p) {
		margin-top: 2em;
	}

	:global(html.VB div.box.chapter h3 + p.p) {
		margin-top: 0;
	}

	:global(html.VB div.box.chapter p.p + br) {
		display: none;
	}

	:global(div.box.chapter x-v.active) {
		color: var(--box-background);
		background: var(--tertiary-color);
		padding: .3em;
		border-radius: .3em;
	}

	:global(div.box.chapter a[data-verse]) {
		display: inline-block;
		font-size: .7em;
		font-weight: 700;
		line-height: 1.6em;
		text-align: center;
		color: var(--tertiary-color);
		margin-right: .5em;
		width: 2em;
		border-radius: .3em;
		background: var(--tertiary-background-light);
		vertical-align: middle;
		cursor: pointer;
		user-select: none;
	}

	:global(div.box.chapter x-v.active a[data-verse]) {
		color: var(--tertiary-color);
		background: var(--box-background);
		margin-bottom: .1em;
	}

	:global(div.box.chapter a[data-verse].favorite) {
		color: var(--background);
		background: var(--tertiary-color);
	}

	:global(div.box.chapter x-v.active a[data-verse].favorite) {
		color: var(--background);
		border: 2px solid var(--background);
		background: var(--tertiary-color);
	}

	:global(div.box.chapter i.favorite-note) {
    	color: var(--tertiary-color);
	    vertical-align: middle;
	    margin: .2em .1em 0 .1em;
    	opacity: .95;
    	cursor: pointer;
    }

	:global(div.box.chapter .fa-question-circle),
	:global(div.box.chapter .fa-location-circle) {
		font-size: .95em;
		margin: 0 .25em;
		color: var(--tertiary-color);
		opacity: .6;
		cursor: pointer;
		user-select: none;
	}

	:global(div.box.chapter x-v.active .fa-question-circle),
	:global(div.box.chapter x-v.active .fa-location-circle) {
		color: var(--box-background);
	}

	:global(div.box.chapter .fa-times-circle) {
		opacity: 1;
	}

	:global(div.box.chapter span[data-type="char"][data-style="add"]) {
		font-style: italic;
		color: var(--box-color-lightest);
		padding-right: .1em;
	}

	:global(div.box.chapter span[data-type="ref"][data-loc]) {
		text-decoration: underline;
		cursor: pointer;
	}

	:global(div.box.chapter div.verse-note),
	:global(div.box.chapter span[data-type="note"][data-style="f"]),
	:global(div.box.chapter span[data-type="note"][data-style="x"]) {
		font-size: .9em;
		font-weight: 700;
		color: var(--tertiary-color);
		padding: 1em 1.9em;
		margin: 1em -1.9em;
		border-radius: .5em;
		background: var(--tertiary-background-light);
		display: none;
	}

	:global(div.box.chapter div.verse-note.show),
	:global(div.box.chapter span[data-type="note"][data-style="f"].show),
	:global(div.box.chapter span[data-type="note"][data-style="x"].show) {
		display: block !important;
	}

	:global(div.box.chapter x-v.active div.verse-note),
	:global(div.box.chapter x-v.active span[data-type="note"][data-style="f"]),
	:global(div.box.chapter x-v.active span[data-type="note"][data-style="x"]) {
		background: var(--tertiary-color);
	}

	:global(div.box.chapter div.verse-note.show::before),
	:global(div.box.chapter span[data-type="note"][data-style="f"].show::before),
	:global(div.box.chapter span[data-type="note"][data-style="x"].show::before) {
		content: "Opmerking";
		display: block;
		font-weight: normal;
		font-size: .7em;
		text-transform: uppercase;
		opacity: .75;
	}

	:global(div.box.chapter div.verse-note.show::before) {
		display: none;
	}

	:global(div.box.chapter span[data-type="note"][data-style="x"].show::before) {
		content: "Verwijzing";
	}

	:global(div.box.chapter span[data-type="char"][data-style="sc"]) {
		font-variant: small-caps;
	}

	:global(div.box.chapter x-v.active span) {
		color: var(--box-background) !important;
	}

	@media (max-device-width: 768px) {
		div.bookmark {
			top: -2.25em;
			right: 0;
		}

		div.duo div.chapter {
			width: 100%;
			padding: 0;
			border-right: none;
		}

		h1 {
			font-size: 2.5em;
		}

		h1 span {
			border-bottom-width: 3px;
		}

		div.duo div.reference {
			display: none;
		}

		div.duo-button {
			margin-top: 2em;
		}

		:global(div.box.chapter h3) {
			border-bottom-width: 3px;
		}

		:global(div.box.chapter div.chapter) {
			font-size: 1.075em;
		}

		:global(div.box.chapter div.content h3) {
			font-size: 1.25em;
		}

		:global(div.box.chapter div.verse-note),
		:global(div.box.chapter span[data-type="note"][data-style="x"]),
		:global(div.box.chapter span[data-type="note"][data-style="f"]) {
			border-radius: 0;
		}
	}
</style>

<div class="box chapter" class:feature class:active class:old_active>
	{#if Helper.is(chapter)}
		<div class="menu duo">
			<div class="begin">
				{#if isType('chapter')}
					{#if Helper.is(uri) && (chapter.code != 'GEN_1')}
						<a class="item" href="/{uri.previous.chapter.uri}" on:click="{event => chapterPrevious(event)}">
							<i class="fas fa-chevron-left"></i>
						</a>
					{/if}
					<div class="title">{chapter.book.name} {chapter.number}</div>
				{:else if Helper.is(uri) && isType('reference')}
					{#if (chapter.code != 'GEN_1') && isReferenceProceed()}
						<a class="item" href="/{uri.previous.chapter.uri}" on:click="{event => referencePrevious(event)}">
							<i class="fas fa-chevron-left"></i>
						</a>
					{/if}
					<div class="title">{properties.reference.name}</div>
				{/if}
			</div>
			<div class="end">
				{#if isType('chapter')}
					{#if $Data.version.audio}
						<div class="item" on:click="{event => audioToggle()}">
							{#if !Helper.is(audio) || (audio_ready && !audio_playing)}
								<i class="fad fa-volume-up"></i>
							{:else if audio_loading}
								<i class="fad fa-spinner fa-spin"></i>
							{:else if audio_playing}
								<i class="fad fa-volume-slash"></i>
							{/if}
						</div>
					{/if}
					<div class="item" on:click="{event => zoomOut()}">
						<i class="fad fa-search-minus"></i>
					</div>
					<div class="item" on:click="{event => zoomIn()}">
						<i class="fad fa-search-plus"></i>
					</div>
					{#if Helper.is(uri) && (chapter.code != 'REV_22')}
						<a class="item" href="/{uri.next.chapter.uri}" on:click="{event => chapterNext(event)}">
							<i class="fas fa-chevron-right"></i>
						</a>
					{/if}
				{/if}
				{#if isType('reference')}
					{#if Helper.is(uri) && (chapter.code != 'REV_22') && isReferenceProceed()}
						<a class="item" href="/{uri.next.chapter.uri}" on:click="{event => referenceNext(event)}">
							<i class="fas fa-chevron-right"></i>
						</a>
					{/if}
					<div class="item" on:click="{event => Slider.close()}">
						<i class="fas fa-times"></i>
					</div>
				{/if}
			</div>
		</div>
		<div bind:this="{content}" class="content">
			<div class="duo">
				<div class="chapter" class:chapter-reference="{Helper.is(references)}">
					{#if $Session.bookmark.chapter === chapter.code}
						<div class="bookmark active" on:click="{event => bookmark('')}">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400">
								<path class="element" d="M105.66,305.66,200,400V0H0V400l94.34-94.34A8,8,0,0,1,105.66,305.66Z"/>
							</svg>
						</div>
					{:else}
						<div class="bookmark" on:click="{event => bookmark(chapter.code)}">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 100">
								<path class="element" d="M48,2V95.17L27.83,75a4,4,0,0,0-5.66,0L2,95.17V2H48m2-2H0V100L23.59,76.41a2,2,0,0,1,2.82,0L50,100V0Z" transform="translate(0 0)"/>
							</svg>
						</div>
					{/if}
					<h1>{chapter.book.name} <span on:click="{event => chapter_list = !chapter_list}">{chapter.number}</span></h1>
					{#if Helper.is(book) && chapter_list}
						<div class="chapters">
							{#each book.chapters as book_chapter}
								<a href="/{book.uri}/{book_chapter.number}" class:active="{book_chapter.number == chapter.number}">{book_chapter.number}</a>
							{/each}
						</div>
					{/if}
					{#if chapter.pericopes.length > 1}
						<div class="list pericopes">
							{#each chapter.pericopes as pericope}
								<div class="item" on:click="{event => toPericope(pericope)}">
									<i class="fad fa-arrow-down"></i>
									<div class="name">
										<i class="fad fa-align-left"></i> {pericope.title}
									</div>
								</div>
							{/each}
						</div>
					{/if}
					{#if Helper.is(intro.html)}
						<h3 class="intro">Wat is dit voor boek?</h3>
						<div class="intro" class:expand="{intro.expand}">
							{@html intro.expand ? intro.html : intro.summary}
							<div class="button tertiary more" on:click="{event => { intro.expand = !intro.expand }}">
								{intro.expand ? 'Minder' : 'Meer'} lezen <i class="fas fa-chevron-{intro.expand ? 'up' : 'down'}"></i>
							</div>
						</div>
					{/if}
					{#if !$Session.tip.favorite}
						<div class="notice compact">
							<i class="far fa-times close" on:click="{event => $Session.tip.favorite = true}" style="margin-right: 0;"></i>
							<i class="fad fa-book-heart" style="margin-left: 0;"></i>
							<span class="normal">Je kunt een vers als favoriet bewaren door op het versnummer te klikken</span>
						</div>
					{/if}
					{#if $Data.version.audio && !$Session.tip.audio}
						<div class="notice compact">
							<i class="far fa-times close" on:click="{event => $Session.tip.audio = true}" style="margin-right: 0;"></i>
							<i class="fad fa-waveform" style="margin-left: 0;"></i>
							<span class="normal">Tip: Om te luisteren, klik op het luidsprekertje bovenaan de pagina</span>
						</div>
					{/if}
					{@html chapter.html}
					{#if isType('chapter')}
						<div class="duo-button">
							{#if Helper.is(uri) && (chapter.code != 'GEN_1')}
								<a class="step button" href="/{uri.previous.chapter.uri}" on:click="{event => chapterPrevious(event)}">
									<i class="fas fa-chevron-left"></i> Vorige
								</a>
							{/if}
							{#if Helper.is(uri) && (chapter.code != 'REV_22')}
								<a class="step button" href="/{uri.next.chapter.uri}" on:click="{event => chapterNext(event)}">
									Volgende <i class="fas fa-chevron-right"></i>
								</a>
							{/if}
						</div>
					{:else if isType('reference')}
						<div class="duo-button">
							{#if Helper.is(uri) && (chapter.code != 'GEN_1') && isReferenceProceed()}
								<a class="step button" href="/{uri.previous.chapter.uri}" on:click="{event => referencePrevious(event)}">
									<i class="fas fa-chevron-left"></i> Vorige
								</a>
							{/if}
							{#if Helper.is(uri) && (chapter.code != 'REV_22') && isReferenceProceed()}
								<a class="step button" href="/{uri.next.chapter.uri}" on:click="{event => referenceNext(event)}">
									Volgende <i class="fas fa-chevron-right"></i>
								</a>
							{/if}
						</div>
					{/if}
				</div>
				<div class="reference active">
					{#if $Data.version.side_reference}
						{#if Helper.is(references)}
							<h4>{references.length} Verwijzing{(references.length > 1) ? 'en' : ''}</h4>
							{#each references as reference}
								<div class="item" on:click="{reference.click}" style="top: {reference.top}px;">
									<div>
										<i class="fad fa-share"></i>
										{reference.name}
									</div>
								</div>
							{/each}
						{:else}
							<h4>Geen verwijzingen</h4>
						{/if}
					{/if}
				</div>
			</div>
		</div>
		<div bind:this="{favorite_element}" class="verse-note">
			<div class="header">
				<div class="title">Favoriet - {chapter.book.name} {chapter.number}:{favorite.number}</div>
				<div class="option" on:click="{event => favoriteClose()}">
					<i class="far fa-times"></i>
				</div>
			</div>
			<textarea bind:this="{favorite_textarea}" rows="4" placeholder="Jouw notitie...">{favorite.note || ''}</textarea>
			<div class="toolbar">
				{#if favorite.remove}
					<div class="option error" on:click="{event => favoriteDelete(favorite)}">
						<i class="fad fa-check"></i>
						<span>Ik weet het zeker!</span>
					</div>
					<div class="option success" on:click="{event => favorite.remove = false}">
						<i class="fad fa-times"></i>
						<span>Nee, niet verwijderen</span>
					</div>
				{:else}
					<div class="option error" on:click="{event => favorite.remove = true}">
						<i class="fad fa-trash-alt"></i>
						<span>Favoriet verwijderen</span>
					</div>
					<div class="option" on:click="{event => favoriteUpdate(favorite)}">
						<i class="fad fa-check"></i>
						<span>Notitie opslaan</span>
					</div>
				{/if}
			</div>
		</div>
	{/if}
</div>